import { useContext, useEffect, useState } from "react";
import EDITMODAL from 'components/editmodal';
import api from "services/api";
import { getHoje } from "components/formatos";
import { getnome } from "functions/gettabconfig";
import config from 'config';
import CAMERACOMPONENT from "components/cameraimagem";
import './style.css';
import FLOATINPUT from "components/inputnumber";
import RADIO from "components/radio";
import { CidadeContext } from "services/cidade";

function AdminTurismoModal(props) {
  const { v4: uuidv4 } = require('uuid');
  const [idturismo, setIdturismo] = useState(0);
  const [tipo, setTipo] = useState(0);
  const [descricao, setDescricao] = useState('');
  const [url_foto, setUrl_foto] = useState('');
  const [url_site, setUrl_site] = useState('');
  const [ind_ativo, setInd_ativo] = useState('S');
  const [cod_cidade, setCod_cidade] = useState(0);
  const [latitude, setLatitude] = useState(0);
  const [longitude, setLongitude] = useState(0);
  const [validadeate, setValidadeate] = useState(getHoje());

  const [mensagem, setMensagem] = useState('');
  const [loading, setLoading] = useState(false);
  const { cidades } = useContext(CidadeContext);



  function salvaTurismo() {
    const dados =
    {
      "id_turismo": idturismo,
      "descricao": descricao,
      "url_foto": url_foto,
      "url_site": url_site,
      "ind_ativo": ind_ativo,
      "tipo": tipo,
      "cod_cidade": cod_cidade,
      "latitude": latitude,
      "longitude": longitude,
      "validadeate": validadeate,
    }
    setLoading(true);
    if (idturismo === 0) {
      api.post(`${config.ADM_TURISMO}`, dados)
        .then(response => {
          if (response.status === 201) {
            setLoading(false);
            props.onRequestClose();
          } else {
            setLoading(false);
            setMensagem(response.response.data.erro)
          }
        })
    } else {
      api.patch(`${config.ADM_TURISMO}/${idturismo}`, dados)
        .then(response => {
          if (response.status === 200) {
            setLoading(false);
            props.onRequestClose();
          } else {
            setLoading(false);
            setMensagem(response.response.data.erro)
          }
        })
    }

  }

  function deletaTurismo(id) {
    setLoading(true);
    api.delete(`${config.ADM_TURISMO}/${idturismo}`)
      .then(response => {
        if (response.status === 200) {
          setLoading(false);
          props.onRequestClose();
        } else {
          setLoading(false);
          setMensagem(response.response.data.erro)
        }
      })
  }
  function SalvarCidade(e) {
    setCod_cidade(e.target.value);
  }

  useEffect(() => {
    if (props.dados.id_turismo !== undefined) {
      setIdturismo(props.dados.id_turismo ?? 0);
      setDescricao(props.dados.descricao ?? '');
      setUrl_foto(props.dados.url_foto ?? '');
      setUrl_site(props.dados.url_site ?? '');
      setInd_ativo(props.dados.ind_ativo ?? 'N');
      setTipo(props.dados.tipo ?? 0);
      setLatitude(props.dados.latitude ?? 0);
      setLongitude(props.dados.longitude ?? 0);
      setCod_cidade(props.dados.cod_cidade ?? 0);
      setValidadeate(props.dados.validade_ate ?? getHoje());
    }

  }, [props.dados])


  return <EDITMODAL
    programa={'PROMOÇÕES'}
    isOpen={props.isOpen}
    onRequestClose={props.onRequestClose}
    loading={loading}
    operacao={props.operacao}
    mensagem={mensagem}
    SalvaParametro={salvaTurismo}
    DeleteParametro={deletaTurismo}
    dcreate={getHoje()}
    ocreate={getnome()}
    dupdate={getHoje()}
    oupdate={getnome()}
  >
    <div>
      <div className="row">
        <div className="col-md-2">
          <label htmlFor="forID" className="form-label">ID</label>
          <input type="text"
            value={idturismo}
            onChange={(e) => setIdturismo(e.target.value)}
            disabled
            className="form-control" id="forTitulo" />
        </div>
        <div className="col-md-8">
          <label htmlFor="tipo" className="form-label">Tipo?</label>
          <RADIO
            chave={'tipo'}
            alabel={['Turismo', 'Hoteis', 'Alimentação', 'Eventos', 'Uteis']}
            avalores={[0, 1, 2, 3, 4]}
            setValor={setTipo}
            valor={tipo}
          />
        </div>
        <div className="col-md-2">
          <label htmlFor="indativo" className="form-label">Ativo?</label>
          <RADIO
            chave={'indativo'}
            avalores={['S', 'N']}
            alabel={['Sim', 'Não']}
            setValor={setInd_ativo}
            valor={ind_ativo}
          />
        </div>
        <div className="col-md-4 mb-3">
          <label htmlFor="InputCidade" className="form-lable mb-1">Cidade</label>
          <div className="form-control mb=3">
            <select className="endereco-cidade"
              name="cidades" id="cidade"
              onChange={SalvarCidade}
              value={cod_cidade}
            >
              <option value="00000000">Escolha a Cidade</option>
              {cidades.map(c => {
                return <option value={c.cod_cidade} key={c.cod_cidade}>{c.cidade} - {c.uf}</option>
              })}
            </select>
          </div>
        </div>
        <div className="col-md-4">
          <label htmlFor="inputValidade" className="form-label">Validade até</label>
          <input type="date"
            value={validadeate}
            onChange={(e) => setValidadeate(e.target.value)}
            className="form-control" id="forValidade" />
        </div>
        <div className="col-md-2">
          <label htmlFor="inputLatitude" className="form-label">Latitude</label>
          <FLOATINPUT
            id={'inputLatitude'}
            css={'NUMEROD8'}
            number={latitude}
            setNumber={setLatitude}
            decimalScale={8}
            allowNegative={true}
          />
        </div>
        <div className="col-md-2">
          <label htmlFor="inputLongitude" className="form-label">Longitude</label>
          <FLOATINPUT
            id={'inputLongitude'}
            css={'NUMEROD8'}
            number={longitude}
            setNumber={setLongitude}
            decimalScale={8}
            allowNegative={true}

          />
        </div>
        <div className="col-md-12">
          <label htmlFor="forDescricao" className="form-label">Descrição</label>
          <input type="text"
            value={descricao}
            onChange={(e) => setDescricao(e.target.value)}
            className="form-control" id="forDescricao" />
        </div>
        <div className="col-md-12">
          <label htmlFor="forSite" className="form-label">Link Site</label>
          <input type="text"
            value={url_site}
            onChange={(e) => setUrl_site(e.target.value)}
            className="form-control" id="forSite" />
        </div>

        <div className="col-md-10">
          <label htmlFor="forFoto" className="form-label">Imagem {url_foto}</label>
          <CAMERACOMPONENT
            heigth={640}
            width={480}
            foto={url_foto}
            setFoto={setUrl_foto}
            class={'foto-aviso'}
            base64={false}
            nomedoarquivo={`t${uuidv4()}-${tipo}}.png`}
            diretorio={'imgtur'}
          />
        </div>
      </div>
    </div>
  </EDITMODAL>
}

export default AdminTurismoModal;